import { createSlice } from "@reduxjs/toolkit";
import { getMenosTalentosThunk } from "./menosTalentos.thunks";

const initialState = {
  menosTalentos: [],
  loading: false,
  error: null,
};

const menosTalentosSlice = createSlice({
  name: "menosTalentos",
  initialState,
  reducers: {
    clearMenosTalentosError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ================================
      // GET TOP 5 TALENTOS A MEJORAR
      // ================================
      .addCase(getMenosTalentosThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMenosTalentosThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.menosTalentos = action.payload;
      })
      .addCase(getMenosTalentosThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMenosTalentosError } = menosTalentosSlice.actions;
export default menosTalentosSlice.reducer;
